import { LocationRoomViewer, type LocationRoomViewerProps } from "@/components/locations/location-room-viewer"
import { WorkspaceFullscreenPanel } from "@/components/workspace/workspace-fullscreen-panel"
import { useTranslation } from "@/hooks/use-translation"

type LocationRoomViewerPanelProps = LocationRoomViewerProps & {
  open: boolean
  onOpenChange: (open: boolean) => void
  locationName: string
  variantName?: string | null
  /** Inside the shot panel: fill that column instead of the locations content inset. */
  nested?: boolean
}

export function LocationRoomViewerPanel({
  open,
  onOpenChange,
  locationName,
  variantName,
  nested = false,
  ...viewerProps
}: LocationRoomViewerPanelProps) {
  const { t } = useTranslation(["workspace"])
  const title =
    variantName != null && variantName.trim() !== ""
      ? t("locationsPage.roomViewer.titleWithVariant", { name: locationName, variant: variantName })
      : t("locationsPage.roomViewer.title", { name: locationName })

  return (
    <WorkspaceFullscreenPanel
      open={open}
      onOpenChange={onOpenChange}
      nested={nested}
      contained={nested}
      fitEntityContent={!nested}
      hideHeader
      title={title}
      description={t("locationsPage.roomViewer.description")}
      bodyClassName="min-h-0 overflow-hidden p-0"
    >
      {open ? <LocationRoomViewer locationName={locationName} variantName={variantName} {...viewerProps} /> : null}
    </WorkspaceFullscreenPanel>
  )
}
